/**
 * Maps scio3 route paths (after /app/) to scio1 ui-router state names.
 * Used by Scio1Frame to send ROUTER_REDIRECT postMessages.
 *
 * State names must match scio1's $stateProvider registrations exactly.
 * Source: scio1/imports/ui/components/account/ and contentManagement/ modules.
 */
export const SCIO1_STATE_MAP: Record<string, string> = {
  // Settings (s/ prefix)
  's/personal-profile': 'app.account.personalProfile',
  's/company-profile': 'app.account.companyProfile',
  's/account-members': 'app.account.accountMembers',
  's/subscription-plan': 'app.account.subscriptionPlan',
  's/payment': 'app.account.payment',
  's/payment-history': 'app.account.paymentHistory',
  's/order-device': 'app.account.orderDevice',
  's/payment-intent': 'app.account.paymentIntent',
  's/payment-thankyou': 'app.account.paymentThankYou',
  's/ordered-device': 'app.account.orderedDevice',
  's/credentials': 'app.account.credentials',
  's/preference-settings': 'app.account.preferenceSettings',
  's/operational-schedule': 'app.account.operationalSchedule',
  's/approval-list': 'app.account.approvalList',
  's/sub-account-billing': 'app.account.subAccountBilling',
  's/coupons': 'app.account.subscriptionCoupons',
  's/proof-of-play-settings': 'app.account.proofOfPlaySettings',
  's/branding-settings': 'app.account.brandingSettings',
  's/monitoring-alert-rules': 'app.account.monitoringAlertRules',
  's/provisioning-templates': 'app.account.provisioningTemplates',
  's/saml-settings': 'app.account.samlSettings',
  's/apikeys': 'app.account.apikeys',
  's/external-coms': 'app.account.externalComs',
  's/integrations': 'app.account.integrations',
  's/share-links-admin': 'app.account.shareLinksAdmin',
  's/datasources-admin': 'app.account.datasourcesAdmin',
  's/feeds-admin': 'app.account.feedsAdmin',
  's/social': 'app.account.social',
  's/functional-locations': 'app.account.functionalLocations',
  's/confirm-linked-account': 'app.account.confirmLinkedAccount',

  // Content management pages
  screenManagement: 'app.screenManagement',
  assetManagement: 'app.assetManagement',
  playlistManagement: 'app.playlistManagement',
  scheduleManagement: 'app.scheduleManagement',
  templateManagement: 'app.templateManagement',
  engageManagement: 'app.engageManagement',
  'crm-management': 'app.crmManagement',
  designManagement: 'app.designManagement',
};

/**
 * Reverse map: scio1 ui-router state name → scio3 route path (after /app/).
 * Used by Scio1Frame to translate CALLBACK_URL events (which send state names)
 * back to scio3 paths for URL synchronization.
 */
export const SCIO1_STATE_TO_PATH: Record<string, string> = Object.fromEntries(
  Object.entries(SCIO1_STATE_MAP).map(([path, state]) => [state, path]),
);
